/*
        1,现金
        93、积分储值卡
        94、储值卡
        99、积分抵现
        995、 扫码收款
        996、代金券
        999、支付宝
        998、微信
        997、转账
        */
       export const PayStyle = {
        xianjin:"1",
        jfczk:"93",
        hyczk:"94",
        jfdx:"99",
        smzf:'995',
        djq:"996",//996
        zfb:"999",
        wx:"998",
        zz:"997",
    }
    
    export const PayIcon = {
        "1":"xianjin2",
        "93":"chuzhiqia",
        "94":"chuzhiqia",
        "99":"jifendixian",
        "995":"saomashoukuan",
        "996":"daijinquan",
        "999":"zhifubao",
        "998":"weixin",
        //"997":"zhifubao",
        "gengduo":"gengduo2",
        "default":"moban1"
    }
    export const getQuantity = (value) => {
        return getRoundValue(isNaN(value) ? 0 : value, "0")
    }
export const getFixedNumber = (value, precision) => {
    return '￥' + getRoundValue(isNaN(value) ? 0 : value, precision || 2)
}

export const getRoundValue = (value, decimal) => {
    if(!decimal) return value
    const pow = Math.pow(10, decimal);
    let returnValue = Math.round(Math.abs(value) * pow) / pow;
    if (value < 0)
        returnValue = -returnValue;
    return returnValue.toFixed(decimal);
}